/* global axios */
import ApiClient from '../ApiClient';

class ScheduledWhatsappMessagesAPI extends ApiClient {
  constructor() {
    super('conversations', {
      saas: true,
      accountScoped: true,
    });
  }

  list(conversationId) {
    return axios.get(
      `${this.url}/${conversationId}/scheduled_whatsapp_messages`
    );
  }

  create({ conversationId, content, scheduledAt, templateParams }) {
    return axios.post(
      `${this.url}/${conversationId}/scheduled_whatsapp_messages`,
      {
        scheduled_whatsapp_message: {
          content,
          scheduled_at: scheduledAt,
          template_params: templateParams,
        },
      }
    );
  }

  update({ conversationId, id, scheduledAt }) {
    return axios.patch(
      `${this.url}/${conversationId}/scheduled_whatsapp_messages/${id}`,
      {
        scheduled_whatsapp_message: {
          scheduled_at: scheduledAt,
        },
      }
    );
  }

  delete({ conversationId, id }) {
    return axios.delete(
      `${this.url}/${conversationId}/scheduled_whatsapp_messages/${id}`
    );
  }
}

export default new ScheduledWhatsappMessagesAPI();
